import { gql } from '@apollo/client';

export const accountFragment = gql`
  fragment AccountFragment on Account {
    id
    name
    email
    permissions {
      id
      permissionId
      granted
    }
    marketLocations {
      id
      name
      externalName
    }
  }
`;
